import React, { useContext, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import config from '../config';
import { GlobalContext } from '../global/GlobalProvider';

export default function HomeTopBanner() {
  const[open, setOpen] = useState();
  const [assetsData, setAssetsData] = useState(null);
  const {loggedIn} = useContext(GlobalContext);
  useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                'whiteLabelName': config.WhiteLable,
              }),
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setAssetsData(data);
          } catch (error) {
            console.error('Fetch error:', error);
          }
        };

        fetchData();
      }, []);

       const newLunch = () => {
              return (<div className="sidebar-box new-launched-sidebar desktop-hide">
                <div className="sidebar-title"> New Launched </div>
                <div className="sidebar-content">
                  <Swiper
                    loop={true}
                    effect={"fade"}
                    // direction={'vertical'}
                    autoplay={{
                      delay: 2000,
                      disableOnInteraction: false,
                    }}
                    modules={[Autoplay]}
                    breakpoints={{
                      320: {
                        direction: "horizontal",
                        slidesPerView: 2,
                        spaceBetween: 5,
                      },
                      767: {
                        direction: "horizontal",
                        slidesPerView: 3,
                        spaceBetween: 5,
                      },
                      1024: {
                        direction: "horizontal",
                        slidesPerView: 3,
                        spaceBetween: 5,
                      },
                      1279: {
                        direction: "vertical",
                        slidesPerView: 1,
                        spaceBetween: 5,
                      },
                    }}
                    className="new-launched-slider"
                  >
                    <SwiperSlide> <img src="images/teen20c.jpg" alt="" /> </SwiperSlide>
                    <SwiperSlide> <img src="images/btable2.jpg" alt="" /> </SwiperSlide>
                    <SwiperSlide> <img src="images/ourroullete.jpg" alt="" /> </SwiperSlide>
                  </Swiper>
                </div>
            </div>
            );
            }


  return (
    <>
    <div className="home-banner">
          <Swiper
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className={`home-banner-slider ${open? 'open' : ''}`}
          >
          {assetsData?.banner?.map((item, index) => (
            <SwiperSlide key={index}> <img src={item.bannerName} alt="" /> </SwiperSlide>
          ))}
          </Swiper>


         {sessionStorage.getItem("loggedIn") || loggedIn ? <button className={`banner-toggle ${open? 'hide' : ''}`} onClick={open =>(setOpen(true))}><i className="fas fa-arrow-down"></i> Current Activities</button> : ''}
        </div>
        {sessionStorage.getItem("loggedIn") || loggedIn ? '' :newLunch()}
    </>
  )
}
